import React from 'react'

export default class InfoBar extends React.Component {
    constructor(props) {
        super(props);
         
    }

    componentDidMount() {
        jQuery(".information-bar").draggable();
    }
    

    componentWillUpdate(nextProps, nextState) {
    }

    render(){
        return (
            <div class="onScreenWindow middle_header information-bar">
                <div class="col-sm-12 title"><i class="fa fa-info"></i></div>
                <div class="col-sm-12">
                    <div class="col-md-6">
                        <span class="building_title tooltip_custom">
                            <i class="fa fa-building-o">
                                <span data-toggle="tooltip" title="Building Name."></span>
                            </i> 
                            {this.props.buildingData != null && (
                                <p>{this.props.buildingData.data.building_name}</p>
                            )}
                        </span>	
                    </div>
                    <div class="col-md-6 right-small">
                        <span class="level_title tooltip_custom">
                            <i class="fa fa-cube">
                                <span data-toggle="tooltip" title="Current Level."></span>
                            </i> 
                            <p>Level {this.props.levelID}</p>
                        </span>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Graphics/Editor/InfoBar.jsx